import React, { useRef } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import EventContent from './EventContent';
import { returnStatusColor } from './returnStatusColor';

const Calendar = ({ posts, onEventClick }) => {
  const calendarRef = useRef(null);

  // Transform posts into FullCalendar events
  const events = posts
    .filter((post) => post.scheduledAt && post.status !== 'draft')
    .map((post) => {
      const { backgroundColor, borderColor } = returnStatusColor(post.status);

      return {
        id: post.id,
        title: post.aspectRatio === '9:16' ? 'Story' : 'Feed',
        start: post.scheduledAt,
        extendedProps: {
          post,
          status: post.status,
          aspectRatio: post.aspectRatio,
          imageUrl: post.path || post.imageUrl,
          caption: post.caption,
        },
        backgroundColor,
        borderColor,
      };
    });

  return (
    <FullCalendar
      ref={calendarRef}
      plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
      initialView='dayGridMonth'
      headerToolbar={{
        left: 'prev,next',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek',
      }}
      events={events}
      eventClick={onEventClick}
      height='100%'
      editable={false}
      selectable={false}
      selectMirror={true}
      dayMaxEvents={false}
      weekends={true}
      allDaySlot={false}
      eventDisplay='block'
      dayHeaderFormat={{
        weekday: 'short',
        day: 'numeric',
      }}
      eventTimeFormat={{
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      }}
      eventContent={(eventInfo) => <EventContent eventInfo={eventInfo} />}
    />
  );
};

export default Calendar;
